<template>
    <form @submit.prevent="validateAndSave" novalidate="true">
        <div class="row">
            <div class="col-md-6 profile-separator-right">
                <div class="row">
                    <div class="col-md-6 p-b-lg">
                        <label>First Name</label>
                        <input type="text" v-model="localUser.first_name" v-validate="'required'" name="first_name" data-vv-as="First Name" class="form-control"/>
                        <label v-show="vErrors.has('first_name')" class="error" v-cloak>{{ vErrors.first('first_name') }}</label>
                    </div>
                    <div class="col-md-6 p-b-lg">
                        <label>Last Name</label>
                        <input name="last_name" data-vv-as="Last Name" type="text" v-model="localUser.last_name" class="form-control" v-validate="'required'" />
                        <label v-show="vErrors.has('last_name')" class="error" v-cloak>{{ vErrors.first('last_name') }}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 p-b-lg">
                        <label>Email</label>
                        <input name="email" data-vv-as="Email" type="text" v-model="localUser.email" class="form-control" v-validate="'required|email'"/>
                        <label v-show="vErrors.has('email')" class="error" v-cloak>{{ vErrors.first('email') }}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 p-b-lg">
                        <label>Phone</label>
                        <input name="phone" type="text" data-vv-as="Phone" v-model="localUser.phone" class="form-control" v-validate="'required|phone'" />
                        <label v-show="vErrors.has('phone')" class="error" v-cloak>{{ vErrors.first('phone') }}</label>
                    </div>
                </div>
            </div>
            <div class="col-md-4 profile-separator-left">
                <div class="row">
                    <div class="col-md-12 p-b-lg">
                        <label>Current Password</label>
                        <input name="currentPassword" data-vv-as="Current Password" type="password" v-model="currentPassword " class="form-control" v-validate="`${newPassword ? 'required' : ''}`"/>
                        <label v-show="vErrors.has('currentPassword')" class="error" v-cloak>{{ vErrors.first('currentPassword') }}</label>
                    </div>
                    <div class="col-md-12 p-b-lg">
                        <label>New Password</label>
                        <input name="newPassword" data-vv-as="New Password" type="password" v-model="newPassword " class="form-control" v-validate="'min:8'" ref="newPassword" />
                        <label v-show="vErrors.has('newPassword')" class="error" v-cloak>{{ vErrors.first('newPassword') }}</label>
                    </div>
                    <div class="col-md-12 p-b-lg">
                        <label>Confirm Password</label>
                        <input data-vv-as="New Password" name="newPassword_confirmation" type="password" v-model="newPassword_confirmation" class="form-control" v-validate="'confirmed:newPassword'" />
                        <label v-show="vErrors.has('newPassword_confirmation')" class="error" v-cloak>{{ vErrors.first('newPassword_confirmation') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 p-b-lg">
                <button class="btn btn-success --edit" :disabled="!formValid">Save</button>
            </div>
        </div>
    </form>
</template>

<script type="text/babel">
    import { Validator } from 'vee-validate';
    import axios from 'axios'
    import dialog from '../utils/dialog'

    const isValidPhone = (phone) => {
        let re = /[^0-9]/g;
        return phone.replace(re, "").length > 9;
    };

    Validator.extend('phone', {
        getMessage: field => 'The ' + field + ' value is not valid.',
        validate: isValidPhone
    });

    const dict = {
        custom: {
            currentPassword: {
                required: 'Current Password is required for password changes.'
            },
        }
    };
    Validator.localize('en', dict);

    export default {
        props: {
            user: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                localUser: this.user,
                currentPassword: '',
                newPassword: '',
                newPassword_confirmation: '',
            }
        },

       computed: {
           formValid () {
               // loop over all contents of the fields object and check if they exist and valid.
               return Object.keys(this.fields).every(field => {
                   return this.fields[field] && this.fields[field].valid;
               });
           }
       },

       methods: {
            validateAndSave() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.save()
                    }
                });

            },
            save() {
                $.loading.show();

                this.localUser.currentPassword = this.currentPassword;
                this.localUser.newPassword = this.newPassword;
                this.localUser.newPassword_confirmation = this.newPassword_confirmation;

                const axiosInstance = axios.put('/api/user/profile/' + this.user.id, this.localUser);
                axiosInstance.then((response) => {
                    $.loading.hide();
                    dialog.success(response.data.msg);
                }).catch((error) => {
                    $.loading.hide();
                    dialog.error(error);
                })
            }
        }
    }
</script>

<style scoped>
    .profile-separator-right {
        border-right: 1px solid #ccc;
    }

    .profile-separator-left {
        border-left: 1px solid #ccc;
        margin-left: -1px;
    }
</style>
